.aha-comment {
  display: flex;
  height: fit-content;
  width: 100%;
}

.aha-comment__avatar-trailing-line {
  border: none;
  margin-top: var(--spacer-1);
  width: 13px;
  float: right;
  height: calc(100% - 34px);

  &.visible {
    border: 1px solid var(--theme-secondary-border);
    border-top: none;
    border-right: none;
    border-bottom: none;
  }
  &.curved {
    border-bottom: 1px solid var(--theme-secondary-border);
    border-bottom-left-radius: 4px;
    height: calc(100% - 17px);
  }
}

.aha-comment__body-side {
  width: 100%;
}

.aha-comment__header {
  display: flex;
  justify-content: space-between;
  padding-top: 4px;
  padding-bottom: 4px;
}

.aha-comment__commenter-name {
  align-content: end;
  margin-left: 15px;
  color: var(--theme-secondary-text);
}

.aha-comment__header-controls {
  margin-bottom: 0px;
  margin-right: 0px;
  display: flex;
}

.aha-comment__body {
  margin-left: 10px;
}

.aha-comment__replies {
  width: calc(100% - 34px);
  margin-left: 34px;
  margin-top: 4px;
  /* var(--spacer-2); */
}

.aha-comment__add-reply {
  color: var(--theme-tertiary-text);
  cursor: pointer;
  margin-left: 7px;
  display: flex;
  gap: 8px;
  width: fit-content;
  margin-bottom: var(--spacer-3);
  padding-top: var(--spacer-1);
}

.aha-comment__share-controls {
  display: flex;
}

.aha-comment__share-controls-hover {
  display: flex;
  transition: opacity 0.2s;
  align-content: end;
  flex-wrap: wrap;
}

.aha-comment__share-controls-hover.show {
  > * {
    display: inherit;
  }
  pointer-events: auto;
}

.aha-comment__share-controls-hover.hide {
  > * {
    display: none;
  }
  pointer-events: none;
}

slot[name='share-controls']::slotted(*) {
  display: flex;
}

.aha-comment__share-controls-date {
  color: var(--theme-tertiary-text);
  padding-left: var(--spacer-1);
  align-content: end;
}
